import React, {useCallback} from "react"
import {Pagination, PaginationItem} from "@mui/material"
import PropTypes from "prop-types"

const PaginationDisplay = ({widget, value, triggerAction}) => {
    const {pageCount, defaultPage} = widget
    const currentPage = value

    const handleClick = useCallback((value) => () => {
        triggerAction(widget?.action, value)
    }, [widget])

    const funcRenderItem = useCallback((params) => {
        return (
            <PaginationItem
                onClick={handleClick(params.page)}
                selected={Number(currentPage) === Number(params.page)} />
        )
    }, [currentPage])

    return (
        <Pagination
            hideNextButton
            hidePrevButton
            count={pageCount}
            defaultPage={defaultPage}
            page={currentPage}
            renderItem={funcRenderItem}
        />
    )
}

PaginationDisplay.propTypes = {
    widget: PropTypes.object
}

export default PaginationDisplay
